import { isAbortError } from '@reatom/framework';
import { isApiCancel } from '@/js/libs/api';
import { UNMOUNT } from './constants';
const isCancelError = (error) => error === UNMOUNT || isApiCancel(error) || isAbortError(error);
export default isCancelError;
